const Place = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.09017 7.99586C7.35684 7.99586 6.75684 7.39616 6.75684 6.6632C6.75684 5.93023 7.35684 5.33053 8.09017 5.33053C8.8235 5.33053 9.4235 5.93023 9.4235 6.6632C9.4235 7.39616 8.8235 7.99586 8.09017 7.99586ZM12.0902 6.79646C12.0902 4.37767 10.3235 2.66519 8.09017 2.66519C5.85684 2.66519 4.09017 4.37767 4.09017 6.79646C4.09017 8.35568 5.39017 10.4213 8.09017 12.8868C10.7902 10.4213 12.0902 8.35568 12.0902 6.79646ZM8.09017 1.33252C10.8902 1.33252 13.4235 3.47812 13.4235 6.79646C13.4235 9.00869 11.6435 11.6274 8.09017 14.6592C4.53684 11.6274 2.75684 9.00869 2.75684 6.79646C2.75684 3.47812 5.29017 1.33252 8.09017 1.33252Z"
        fill="#5A5955"
      />
    </svg>
  );
};

export default Place;
